import './style.scss';
import React from 'react';

function sizeClass(size) {
  switch (size) {
    case 'xs':
      return 'text--xs';
    case 'sm':
      return 'text--sm';
    case 'md':
      return 'text--md';
    case 'lg':
      return 'text--lg';
    case 'xl':
      return 'text--xl';
    case 'xxl':
      return 'text--xxl';
    default:
      return '';
  }
}

function weightClass(weight) {
  switch (weight) {
    case 'light':
      return 'text--300';
    case 'reg':
      return 'text--400';
    case 'med':
      return 'text--500';
    case 'bold':
      return 'text--700';
    default:
      return '';
  }
}

function marginClass(margin) {
  switch (margin) {
    case 'none':
      return 'text--margin-none';
    default:
      return '';
  }
}

function shadowClass(shadow) {
  return shadow === 'light'
    ? 'text--light-shadow'
    : shadow ? 'text--shadow' : '';
}

function titleClass(isTitle) {
  return isTitle ? 'text--title' : '';
}

function displayClass(isDisplay) {
  return isDisplay ? 'text--display' : '';
}

function secondaryClass(isSecondary) {
  return isSecondary ? 'text--secondary' : '';
}

function darkBGClass(hasDarkBG) {
  return hasDarkBG ? 'text--dark-bg' : '';
}

function alignClass(align) {
  switch (align) {
    case 'left':
      return 'text-left';
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    default:
      return '';
  }
}

function errorClass(isError) {
  return isError ? 'text--error' : '';
}

function successClass(isSuccess) {
  return isSuccess ? 'text--success' : '';
}

function responsiveClasses({ lg, xl }) {
  return [
    lg && lg.size ? `lg-${sizeClass(lg.size)}` : '',
    xl && xl.size ? `xl-${sizeClass(xl.size)}` : ''
  ].filter(c => !!c);
}

export function baseClasses(props = {}) {
  return [
    props.className || '',
    sizeClass(props.size),
    weightClass(props.weight),
    marginClass(props.margin),
    shadowClass(props.shadow),
    titleClass(props.title),
    displayClass(props.display),
    secondaryClass(props.secondary),
    darkBGClass(props.darkBG),
    alignClass(props.align),
    errorClass(props.error),
    successClass(props.success)
  ].filter(c => !!c);
}

export default function Text(props) {
  const Tag = props.tag || 'div';
  const children = props.children || null;
  const id = props.id || null;
  const otherProps = props.otherProps || {};
  const className = textClasses(props);

  return (
    <Tag className={className} id={id} {...otherProps}>
      {children}
    </Tag>
  );
}

export function textClasses(props) {
  return (
    baseClasses(props)
      .concat(responsiveClasses(props))
      .join(' ') || null
  );
}
